"use strict";
/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * ČVS - API
 * OpenAPI spec version: 1.1.529
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmsRequestPackage = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.SmsRequestPackage = {
    CLUBS: 'CLUBS',
    CLUBS_ALL: 'CLUBS_ALL',
    BEACH_MEN: 'BEACH_MEN',
    BEACH_WOMEN: 'BEACH_WOMEN',
    BEACH_ALL: 'BEACH_ALL',
    ALL: 'ALL',
    COMPETITION: 'COMPETITION',
};
